/* ============================================================
   cs-product.js   -   section: cs-product
   Gallery, variant selection, related products.
   Add to cart itself is handled by cs-cart-drawer.js.
   ============================================================ */
(function () {
  function init(root) {
    if (root.dataset.csReady) return;
    root.dataset.csReady = '1';

    /* ---------- gallery ---------- */
    var track = root.querySelector('[data-cs-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = root.querySelectorAll('[data-cs-thumb]');
    var dots = root.querySelectorAll('.cs-gal__dots span');

    function goTo(i) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function current() {
      return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    }
    function mark(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }
    if (track && slides.length > 1) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { mark(current()); ticking = false; });
      }, { passive: true });
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goTo(n); }); });
      var prev = root.querySelector('[data-cs-prev]'), next = root.querySelector('[data-cs-next]');
      if (prev) prev.addEventListener('click', function () { goTo((current() - 1 + slides.length) % slides.length); });
      if (next) next.addEventListener('click', function () { goTo((current() + 1) % slides.length); });
    }
    function showMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(mediaId)) { goTo(i); return; }
      }
    }

    /* ---------- variants ---------- */
    var dataEl = root.querySelector('[data-cs-product-json]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : null;
    var fieldsets = root.querySelectorAll('[data-cs-option]');
    var idInput = root.querySelector('[data-cs-variant-id]');
    var addBtn = root.querySelector('[data-cs-add]');
    var addLabel = root.querySelector('[data-cs-add-label]');
    var priceNow = root.querySelector('[data-cs-price-now]');
    var priceWas = root.querySelector('[data-cs-price-was]');

    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0] || null;
    }
    /* Grey out values that have no available variant with the other picks. */
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('.cs-opt__value').forEach(function (label) {
          var input = label.querySelector('input');
          var test = opts.slice(); test[i] = input.value;
          var v = findVariant(test);
          label.classList.toggle('is-out', !v || !v.available);
        });
      });
    }
    function update() {
      var opts = selected();
      var v = findVariant(opts);
      fieldsets.forEach(function (fs, i) {
        var out = fs.querySelector('[data-cs-option-value]');
        if (out) out.textContent = opts[i] || '';
      });
      markAvailability(opts);

      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = 'Add to cart';
      /* sold variant: swap in "Ask me to find it" */
      var find = root.querySelector('[data-cs-find-wrap]');
      addBtn.hidden = !v.available;
      if (find) {
        find.hidden = v.available;
        find.setAttribute('data-cs-find', (dataEl.dataset.title || '') + (v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : ''));
      }
      if (window.CS) {
        priceNow.textContent = CS.money(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = CS.money(v.compare_at_price);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }
      if (v.featured_media) showMedia(v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', url.toString());
    }
    if (data && fieldsets.length) {
      root.addEventListener('change', function (e) { if (e.target.closest('[data-cs-option]')) update(); });
      markAvailability(selected());
    }

    /* ---------- related ---------- */
    var rel = root.querySelector('[data-cs-related]');
    if (rel && rel.dataset.url && !rel.children.length) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        fetch(rel.dataset.url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('[data-cs-related]');
            if (next && next.innerHTML.trim()) rel.innerHTML = next.innerHTML;
          })
          .catch(function () {});
      }, { rootMargin: '600px 0px' });
      io.observe(rel);
    }
  }

  function boot() { document.querySelectorAll('[data-cs-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
